//#region src/client_api_version.ts
var ClientApiVersion = /* @__PURE__ */ function(ClientApiVersion) {
	ClientApiVersion[ClientApiVersion["Default"] = 0] = "Default";
	ClientApiVersion[ClientApiVersion["Supports400ErrorCode"] = 1] = "Supports400ErrorCode";
	ClientApiVersion[ClientApiVersion["SupportsNewAuthCall"] = 2] = "SupportsNewAuthCall";
	ClientApiVersion[ClientApiVersion["SupportsNewUserLocationFormat"] = 3] = "SupportsNewUserLocationFormat";
	ClientApiVersion[ClientApiVersion["SupportsErrorMessage"] = 4] = "SupportsErrorMessage";
	return ClientApiVersion;
}(ClientApiVersion || {});
//#endregion
export { ClientApiVersion };

//# sourceMappingURL=client_api_version.js.map